import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Stack from '@mui/material/Stack';
// import ColorModeSelect from './themes/ColorModeSelect';
import SignInCard from './SignInSide.tsx';
import Content from './Content.tsx';
// import AppTheme from './themes/AppTheme.tsx';
import { Box } from '@mui/material';

export default function Login(props: { disableCustomTheme?: boolean }) {
  return (
    <Box sx={{background:{xs:'transparent', sm:'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))'},height:{xs:'100%', sm:'100vh',md:'100vh'}}}>
      <CssBaseline enableColorScheme />
      {/* <ColorModeSelect sx={{ position: 'fixed', top: '1rem', right: '1rem' }} /> */}
      <Stack
        direction="column"
        component="main"
        sx={[
          {
            justifyContent: 'center',
            height: 'calc((1 - var(--template-frame-height, 0)) * 100%)',
            marginTop: 'max(0px - var(--template-frame-height, 0px), 0px)',
            minHeight: '100%',
          },
          // (theme) => ({
          //   '&::before': {
          //     content: '""',
          //     display: 'block',
          //     position: 'absolute',
          //     zIndex: -1,
          //     inset: 0,
          //     backgroundImage:
          //       'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
          //     backgroundRepeat: 'no-repeat',
          //     ...theme.applyStyles('dark', {
          //       backgroundImage:
          //         'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
          //     }),
          //   },
          // }),
        ]}
      >
        <Stack
          direction={{ xs: 'column-reverse', md: 'row' }}
          sx={{
            justifyContent: 'center',
            gap: { xs: 6, sm: 6 ,md:12 },
            p: 2,
            mx: 'auto',
          }}
        >
          <Stack
            direction={{ xs: 'column-reverse', md: 'row' }}
            sx={{
              justifyContent: 'center',
              gap: { xs: '20px', sm: '20px' ,md:12 },
              p: { xs: 0, sm:0,md:4 },
              m: 'auto',
            }}
          >
            <Content />
            <SignInCard />
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
}
